/* ── TALLTITUDE LP ── */
(function () {
  'use strict';

  var CART_SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  function isModalCart() {
    return !!(window.theme && window.theme.settings && window.theme.settings.cartType === 'modal');
  }

  function modalCartSectionsBody() {
    if (!isModalCart()) return {};
    return {
      sections: CART_SECTIONS,
      sections_url: window.location.pathname || '/'
    };
  }

  function getCartAddUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
  }

  function fetchCartSections() {
    var path = window.location.pathname || '/';
    var sep = path.indexOf('?') >= 0 ? '&' : '?';
    return fetch(path + sep + 'sections=' + CART_SECTIONS, { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  /** Refresh drawer markup and open cart — same contract as bundle-builder.js */
  function completeCartAdd(data, detail) {
    detail = detail || {};
    var payload = Object.assign({}, data);
    var firstItem = payload.items && payload.items[0];
    if (!payload.key && firstItem && firstItem.key) payload.key = firstItem.key;
    if (!payload.variant_id && firstItem && firstItem.variant_id) payload.variant_id = firstItem.variant_id;

    function emit(response) {
      document.body.dispatchEvent(
        new CustomEvent('shapes:cart:afteradditem', {
          bubbles: true,
          detail: {
            response: response,
            sourceId: detail.sourceId || '',
            bundle: !!detail.bundle
          }
        })
      );
    }

    if (!isModalCart()) {
      emit(payload);
      return Promise.resolve(payload);
    }

    if (payload.sections) {
      emit(payload);
      return Promise.resolve(payload);
    }

    return fetchCartSections().then(function (sections) {
      emit(Object.assign({}, payload, { sections: sections }));
      return payload;
    });
  }

  function postCartAdd(body) {
    var headers = { 'Content-Type': 'application/json', Accept: 'application/javascript' };
    if (typeof fetchConfigDefaults === 'function') {
      headers = Object.assign({}, fetchConfigDefaults('application/javascript').headers || {}, headers);
    }
    var payload = Object.assign({}, body, modalCartSectionsBody());
    return fetch(getCartAddUrl(), {
      method: 'POST',
      headers: headers,
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || (data && data.status)) {
          var err = new Error(
            (data && (data.description || data.message)) ||
              (window.theme && window.theme.strings && window.theme.strings.cartError) ||
              'Cart error'
          );
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ─ Scroll reveal ─ */
  function initReveal() {
    var els = document.querySelectorAll('.tlp-reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ─ FAQ accordion ─ */
  function initFaq() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.tlp-faq__question');
      if (!btn) return;
      var item = btn.closest('.tlp-faq__item');
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.tlp-faq__item.is-open').forEach(function (i) {
        i.classList.remove('is-open');
        i.querySelector('.tlp-faq__question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ─ Offer module ─ */
  function initOffer() {
    var dataEl = document.getElementById('TlpProductData');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var variants = data.variants || [];
    var moneyFormat = data.money_format || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }

    /* State */
    var selectedFlavor = '';
    var selectedPurchase = 'subscribe'; /* 'subscribe' | 'one_time' */
    var selectedVariantId = variants[0] ? variants[0].id : null;
    var productId = data.product_id != null ? data.product_id : null;

    function getVariant() {
      if (selectedVariantId != null) {
        var byId = variants.find(function (v) {
          return Number(v.id) === Number(selectedVariantId);
        });
        if (byId) return byId;
      }
      return variants.find(function (v) {
        return v.flavor_key === selectedFlavor;
      }) || variants[0];
    }

    function readVariantIdFromBundleDom() {
      var bundle = document.getElementById('bundle');
      if (!bundle) return null;
      var sel = bundle.querySelector('select[name="id"]');
      if (sel && sel.value) {
        var a = parseInt(sel.value, 10);
        if (!isNaN(a)) return a;
      }
      var radioChecked = bundle.querySelector('input[type="radio"][name="id"]:checked');
      if (radioChecked && radioChecked.value) {
        var r = parseInt(radioChecked.value, 10);
        if (!isNaN(r)) return r;
      }
      var inputs = bundle.querySelectorAll('input[name="id"]');
      for (var i = 0; i < inputs.length; i++) {
        var t = inputs[i].getAttribute('type');
        if (t === 'search' || t === 'radio') continue;
        if (inputs[i].value) {
          var b = parseInt(inputs[i].value, 10);
          if (!isNaN(b)) return b;
        }
      }
      return null;
    }

    function applyExternalVariantId(vid) {
      if (vid == null || isNaN(Number(vid))) return;
      var n = Number(vid);
      if (selectedVariantId === n) return;
      if (!variants.some(function (v) { return Number(v.id) === n; })) return;
      selectedVariantId = n;
      renderPrices();
    }

    function initOfferVariantSyncWithTheme() {
      document.addEventListener('theme:variant:change', function (e) {
        var d = e.detail;
        if (!d || !d.variant) return;
        if (productId != null && d.product && Number(d.product.id) !== Number(productId)) return;
        applyExternalVariantId(d.variant.id);
      });
      document.addEventListener('shapes:product:variantchange', function (e) {
        var d = e.detail;
        if (!d || !d.variant) return;
        var bundle = document.getElementById('bundle');
        var root = e.target;
        if (!bundle || !root || !bundle.contains(root)) return;
        applyExternalVariantId(d.variant.id);
      });
      function onVariantIdControlChange(e) {
        var t = e.target;
        if (!t || t.name !== 'id') return;
        var bundle = document.getElementById('bundle');
        if (!bundle || !bundle.contains(t)) return;
        if (t.type === 'radio' && !t.checked) return;
        var raw = t.value;
        if (!raw && t.type === 'radio') {
          var c = bundle.querySelector('input[type="radio"][name="id"]:checked');
          raw = c ? c.value : '';
        }
        applyExternalVariantId(parseInt(raw, 10));
      }
      document.addEventListener('change', onVariantIdControlChange, true);
      document.addEventListener('input', onVariantIdControlChange, true);
      [0, 400, 1200, 2500].forEach(function (ms) {
        setTimeout(function () {
          var vid = readVariantIdFromBundleDom();
          if (vid != null) applyExternalVariantId(vid);
        }, ms);
      });

      var bundleEl = document.getElementById('bundle');
      var moDebounce;
      function scheduleReadVariantFromDom() {
        clearTimeout(moDebounce);
        moDebounce = setTimeout(function () {
          var vid = readVariantIdFromBundleDom();
          if (vid != null) applyExternalVariantId(vid);
        }, 60);
      }
      if (bundleEl && typeof MutationObserver !== 'undefined') {
        new MutationObserver(scheduleReadVariantFromDom).observe(bundleEl, {
          subtree: true,
          attributes: true,
          attributeFilter: ['value', 'checked'],
          childList: true
        });
      }
    }

    /**
     * KaChing (and similar) prints bundle savings like "SAVE $58.47" in the app block.
     * Subscription vs one-time variant math (TlpProductData) is NOT the bundle discount — parse the UI text.
     */
    function extractKachingBundleSaveCents(appRoot) {
      if (!appRoot) return null;
      var t = (appRoot.innerText || '').replace(/\u00a0/g, ' ');
      var best = 0;
      var patterns = [
        /SAVE\s*\$\s*([\d,]+(?:\.\d{1,2})?)/gi,
        /Save\s*\$\s*([\d,]+(?:\.\d{1,2})?)/gi,
        /you\s+save\s*\$\s*([\d,]+(?:\.\d{1,2})?)/gi,
        /total\s+savings?\s*:?\s*\$\s*([\d,]+(?:\.\d{1,2})?)/gi,
        /\$\s*([\d,]+(?:\.\d{1,2})?)\s*off/gi
      ];
      for (var p = 0; p < patterns.length; p++) {
        var re = patterns[p];
        var m;
        re.lastIndex = 0;
        while ((m = re.exec(t)) !== null) {
          var n = parseFloat(String(m[1]).replace(/,/g, ''));
          if (!isNaN(n) && n > best) best = n;
        }
      }
      if (best > 0) return Math.round(best * 100);
      return null;
    }

    function renderSavingsLine() {
      var savings = document.querySelector('#bundle [data-tlp-savings]') || document.querySelector('[data-tlp-savings]');
      if (!savings) return;

      var appBlock = document.querySelector('#bundle .lv2-offer-app-block');
      if (appBlock && (appBlock.textContent || '').trim().length > 0) {
        var kCents = extractKachingBundleSaveCents(appBlock);
        if (kCents != null && kCents > 0) {
          savings.textContent = '✅ You\'re saving ' + formatMoney(kCents) + ' on this order';
          savings.style.display = '';
          return;
        }
        savings.textContent = '';
        savings.style.display = 'none';
        return;
      }

      var v = getVariant();
      if (!v) {
        savings.textContent = '';
        savings.style.display = 'none';
        return;
      }
      if (selectedPurchase === 'subscribe' && v.subscription_price && v.price) {
        var saved = v.price - v.subscription_price;
        savings.textContent = '✅ You\'re saving ' + formatMoney(saved) + ' on this order';
        savings.style.display = '';
      } else {
        savings.textContent = '';
        savings.style.display = 'none';
      }
    }

    function renderPrices() {
      var v = getVariant();
      if (!v) return;

      var oneTime = document.querySelector('[data-tlp-price-one-time]');
      var subPrice = document.querySelector('[data-tlp-price-subscribe]');
      var subWas = document.querySelector('[data-tlp-price-was]');
      var subPer = document.querySelector('[data-tlp-price-per-sub]');
      var otPer = document.querySelector('[data-tlp-price-per-ot]');

      if (oneTime && v.price) oneTime.textContent = formatMoney(v.price);
      if (subPrice && v.subscription_price) subPrice.textContent = formatMoney(v.subscription_price);
      if (subWas && v.price) subWas.textContent = formatMoney(v.price);
      if (subPer && v.subscription_price) subPer.textContent = '$' + (v.subscription_price / 100 / 30).toFixed(2) + '/day';
      if (otPer && v.price) otPer.textContent = '$' + (v.price / 100 / 30).toFixed(2) + '/day';

      renderSavingsLine();

      var ctaBtn = document.querySelector('[data-tlp-add-to-cart]');
      if (ctaBtn) {
        var available = v.available !== false;
        ctaBtn.disabled = !available;
        if (available) {
          var baseLabel = ctaBtn.dataset.tlpLabelAdd || 'Add to Cart';
          var ctaPrice = (selectedPurchase === 'subscribe' && v.subscription_price) ? v.subscription_price : v.price;
          ctaBtn.textContent = ctaPrice ? baseLabel + '  ' + formatMoney(ctaPrice) : baseLabel;
        } else {
          ctaBtn.textContent = 'Out of Stock';
        }
      }
    }

    /* Flavor selector */
    document.addEventListener('click', function (e) {
      var opt = e.target.closest('.tlp-flavor-opt');
      if (!opt) return;
      var group = opt.closest('.tlp-flavor-opts');
      if (!group) return;
      group.querySelectorAll('.tlp-flavor-opt').forEach(function (o) {
        o.classList.remove('is-active');
        o.setAttribute('aria-pressed', 'false');
      });
      opt.classList.add('is-active');
      opt.setAttribute('aria-pressed', 'true');
      selectedFlavor = opt.dataset.tlpFlavor || '';
      var vMatch = variants.find(function (x) {
        return x.flavor_key === selectedFlavor;
      });
      if (vMatch) selectedVariantId = vMatch.id;
      renderPrices();
    });

    /* Subscribe badge toggle */
    document.addEventListener('click', function (e) {
      var badge = e.target.closest('[data-tlp-sub-toggle]');
      if (!badge) return;
      var isActive = badge.classList.toggle('is-active');
      badge.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      selectedPurchase = isActive ? 'subscribe' : 'one_time';
      renderPrices();
    });

    /* Add to cart */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tlp-add-to-cart]');
      if (!btn) return;
      var v = getVariant();
      if (!v || !v.id) return;

      var body = { id: v.id, quantity: 1 };
      if (selectedPurchase === 'subscribe' && v.selling_plan_id) {
        body.selling_plan = v.selling_plan_id;
      }

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';

      postCartAdd(body)
        .then(function (data) {
          return completeCartAdd(data, { sourceId: btn.id || '' });
        })
        .then(function () {
          btn.textContent = 'Added! ✓';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          alert('Something went wrong. Please try again.');
        });
    });

    initOfferVariantSyncWithTheme();
    var firstDomVid = readVariantIdFromBundleDom();
    if (firstDomVid != null) applyExternalVariantId(firstDomVid);

    /* Init: pick first active flavor; purchase mode is always 'subscribe' */
    var firstFlavor = document.querySelector('.tlp-flavor-opt.is-active');
    if (firstFlavor) {
      selectedFlavor = firstFlavor.dataset.tlpFlavor || '';
      var vf = variants.find(function (x) {
        return x.flavor_key === selectedFlavor;
      });
      if (vf) selectedVariantId = vf.id;
    }
    renderPrices();

    var kachingEl = document.querySelector('#bundle .lv2-offer-app-block');
    var kDeb;
    function scheduleRenderSavings() {
      clearTimeout(kDeb);
      kDeb = setTimeout(renderSavingsLine, 100);
    }
    if (kachingEl && typeof MutationObserver !== 'undefined') {
      new MutationObserver(scheduleRenderSavings).observe(kachingEl, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true
      });
    }
    [0, 400, 1200, 2500].forEach(function (ms) {
      setTimeout(scheduleRenderSavings, ms);
    });
  }

  /* ─ Proof carousel (infinite loop) ─ */
  /* ─ Generic infinite-scroll carousel factory ─ */
  function buildCarousel(wrap, trackSel, cardSel, prevSel, nextSel) {
    var track = wrap.querySelector(trackSel);
    if (!track) return;
    var prevBtn = wrap.querySelector(prevSel);
    var nextBtn = wrap.querySelector(nextSel);
    var cards = Array.from(track.querySelectorAll(cardSel));
    if (cards.length < 2) return;

    cards.forEach(function(c) { track.appendChild(c.cloneNode(true)); });
    /* Prepend in reverse so order stays [clone0…cloneN-1] left-to-right; forward insertBefore(firstChild) reverses and breaks prev-from-first (shows duplicate first slide). */
    for (var pi = cards.length - 1; pi >= 0; pi--) {
      track.insertBefore(cards[pi].cloneNode(true), track.firstChild);
    }

    var allCards = Array.from(track.querySelectorAll(cardSel));
    var current = cards.length;
    var isAnimating = false;

    function getStep() {
      var gap = parseFloat(window.getComputedStyle(track).gap) || 16;
      return allCards[0].offsetWidth + gap;
    }

    function goTo(idx, animate) {
      track.style.transition = (animate === false) ? 'none' : 'transform 0.4s cubic-bezier(0.25,0.46,0.45,0.94)';
      track.style.transform = 'translateX(-' + (idx * getStep()) + 'px)';
      current = idx;
    }

    goTo(current, false);

    track.addEventListener('transitionend', function() {
      isAnimating = false;
      /* Snap from clone strips to equivalent real slides (indices n … 2n−1) */
      if (current >= cards.length * 2) goTo(current - cards.length, false);
      else if (current < cards.length) goTo(current + cards.length, false);
    });

    function next() { if (!isAnimating) { isAnimating = true; goTo(current + 1, true); } }
    function prev() { if (!isAnimating) { isAnimating = true; goTo(current - 1, true); } }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);
    window.addEventListener('resize', function() { goTo(current, false); });
  }

  function initProofCarousel() {
    document.querySelectorAll('[data-tlp-proof-carousel]').forEach(function (wrap) {
      buildCarousel(wrap, '.tlp-proof__track', '.tlp-proof-card', '.tlp-proof__prev', '.tlp-proof__next');
    });
  }

  function initCollageCarousel() {
    var wrap = document.querySelector('[data-tlp-collage-carousel]');
    if (wrap) buildCarousel(wrap, '.tlp-collage__track', '.tlp-collage__card', '.tlp-collage__prev', '.tlp-collage__next');
  }

  /* ─ Offer image gallery ─ */
  function initOfferGallery() {
    var gallery = document.querySelector('[data-tlp-gallery]');
    if (!gallery) return;
    var images = Array.from(gallery.querySelectorAll('.tlp-offer__gallery-img'));
    if (images.length < 2) return;
    var prevBtn = gallery.querySelector('.tlp-gallery__prev');
    var nextBtn = gallery.querySelector('.tlp-gallery__next');
    var current = 0;

    function show(index) {
      images[current].classList.add('tlp-gallery-hidden');
      current = (index + images.length) % images.length;
      images[current].classList.remove('tlp-gallery-hidden');
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
  }

  /* ─ Bundle builder ─ */
  function initBundle() {
    var dataEl = document.getElementById('TlpBundleData');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants    = data.variants    || [];
    var tiers       = data.tiers       || [];
    var flavorInfo  = data.flavor_info || {};
    var moneyFormat = data.money_format || '${{amount}}';

    if (!variants.length) return;

    var flavorsEl   = document.querySelector('[data-tlp-flavors]');
    var tiersEl     = document.querySelector('[data-tlp-tiers]');
    var tierFill    = tiersEl ? tiersEl.querySelector('[data-tlp-tier-fill]') : null;
    var tierItems   = tiersEl ? Array.from(tiersEl.querySelectorAll('[data-tlp-tier]')) : [];
    var ctaBtn        = document.querySelector('[data-tlp-bundle-atc]');
    var savingsMsgEl = document.querySelector('[data-tlp-savings-message]');
    var atcHintEl     = document.querySelector('[data-tlp-atc-hint]');

    if (!flavorsEl) return;

    function escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    /** Old total (cents): compare-at / MSRP sum per variant; subscribe also considers tier one-time as floor */
    function getOldTotalCents(total, activeTier, selectedPurchase) {
      var variantSum = 0;
      variants.forEach(function (v) {
        var q = qtys[v.id] || 0;
        if (!q) return;
        var cap = v.compare_at_price;
        var per = Number(v.price);
        if (cap != null && cap !== '' && Number(cap) > per) per = Number(cap);
        variantSum += q * per;
      });
      var tierOt = 0;
      if (activeTier && selectedPurchase === 'subscribe') {
        var otp = parseFloat(activeTier.onetime_price_per_bag);
        if (!isNaN(otp)) tierOt = Math.round(total * otp * 100);
      }
      return Math.max(variantSum, tierOt);
    }

    /* State */
    var qtys = {};
    var selectedPurchase = 'subscribe';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }

    /* ── Render flavor rows ── */
    flavorsEl.innerHTML = '';
    variants.forEach(function (v) {
      var row = document.createElement('div');
      row.className = 'tlp-bundle__flavor-row';
      row.dataset.variantId = v.id;

      var key  = (v.title || '').toLowerCase();
      var desc = flavorInfo[key] || '';

      var imgHtml = v.image
        ? '<img src="' + v.image + '" alt="' + v.title + '" class="tlp-bundle__flavor-img" width="56" height="56" loading="lazy">'
        : '<div class="tlp-bundle__flavor-img"></div>';

      var unavailHtml = v.available
        ? ''
        : '<span class="tlp-bundle__flavor-unavailable">Out of stock</span>';

      row.innerHTML = imgHtml
        + '<div class="tlp-bundle__flavor-info">'
          + '<span class="tlp-bundle__flavor-name">' + v.title + '</span>'
          + (desc ? '<span class="tlp-bundle__flavor-desc">' + desc + '</span>' : '')
          + unavailHtml
        + '</div>'
        + '<div class="tlp-bundle__qty">'
          + '<button type="button" class="tlp-bundle__qty-btn tlp-bundle__qty-dec" data-variant="' + v.id + '" aria-label="Remove one ' + v.title + '" disabled>\u2212</button>'
          + '<span class="tlp-bundle__qty-num" data-qty-display="' + v.id + '">0</span>'
          + '<button type="button" class="tlp-bundle__qty-btn tlp-bundle__qty-inc" data-variant="' + v.id + '" aria-label="Add one ' + v.title + '"' + (v.available ? '' : ' disabled') + '>+</button>'
        + '</div>';

      flavorsEl.appendChild(row);
      qtys[v.id] = 0;
    });

    /* ── Helpers ── */
    function getTotalBags() {
      return Object.keys(qtys).reduce(function (sum, id) { return sum + (qtys[id] || 0); }, 0);
    }

    function getActiveTierIdx(total) {
      var idx = -1;
      tiers.forEach(function (t, i) {
        var min = t.bags_min || 1;
        var max = t.bags_max || 0;
        if (total >= min && (max === 0 || total <= max)) idx = i;
      });
      return idx;
    }

    /* ── Update UI after any qty change ── */
    function updateUI() {
      var total        = getTotalBags();
      var activeTierIdx = getActiveTierIdx(total);
      var activeTier   = activeTierIdx >= 0 ? tiers[activeTierIdx] : null;
      var tierCount    = tierItems.length;

      /* Tier meter */
      tierItems.forEach(function (item, idx) {
        item.classList.toggle('is-active', idx === activeTierIdx);
        item.classList.toggle('is-passed', idx < activeTierIdx);
      });
      if (tierFill) {
        var pct = activeTierIdx >= 0 && tierCount > 1
          ? (activeTierIdx / (tierCount - 1)) * 100
          : 0;
        tierFill.style.width = pct + '%';
      }

      /* Row highlight */
      Array.from(flavorsEl.querySelectorAll('.tlp-bundle__flavor-row')).forEach(function (row) {
        var vId = parseInt(row.dataset.variantId, 10);
        row.classList.toggle('is-selected', (qtys[vId] || 0) > 0);
      });

      /* Decrement button states */
      variants.forEach(function (v) {
        var dec = flavorsEl.querySelector('.tlp-bundle__qty-dec[data-variant="' + v.id + '"]');
        if (dec) dec.disabled = (qtys[v.id] || 0) === 0;
      });

      /* Tier price labels — update per sub/otp selection */
      tierItems.forEach(function (item, idx) {
        var priceEl = item.querySelector('[data-tlp-tier-price]');
        if (!priceEl || !tiers[idx]) return;
        var ppb = parseFloat(
          selectedPurchase === 'subscribe'
            ? tiers[idx].sub_price_per_bag
            : tiers[idx].onetime_price_per_bag
        );
        priceEl.textContent = !isNaN(ppb) ? '$' + ppb.toFixed(2) + '/bag' : '';
      });

      /* Hint + savings pill (replaces bag × $/ea = total) */
      if (atcHintEl) atcHintEl.hidden = total !== 0;
      if (savingsMsgEl) {
        if (total === 0 || !activeTier) {
          savingsMsgEl.hidden = true;
          savingsMsgEl.innerHTML = '';
        } else {
          var ppbS = parseFloat(
            selectedPurchase === 'subscribe'
              ? activeTier.sub_price_per_bag
              : activeTier.onetime_price_per_bag
          );
          if (isNaN(ppbS)) {
            savingsMsgEl.hidden = true;
            savingsMsgEl.innerHTML = '';
          } else {
            var newCents = Math.round(total * ppbS * 100);
            var oldCents = getOldTotalCents(total, activeTier, selectedPurchase);
            var saveCents = Math.max(0, oldCents - newCents);
            if (saveCents > 0) {
              savingsMsgEl.hidden = false;
              savingsMsgEl.innerHTML =
                '<span class="tlp-bundle__savings-emoji" aria-hidden="true">\uD83D\uDCB0</span> ' +
                'You\u2019re saving <strong>' +
                formatMoney(saveCents) +
                '</strong> compared to full price.';
            } else {
              savingsMsgEl.hidden = true;
              savingsMsgEl.innerHTML = '';
            }
          }
        }
      }

      /* CTA button — label + strikethrough old + new price */
      if (ctaBtn) {
        var baseLabel = ctaBtn.dataset.tlpLabelAdd || 'Add To Cart \u2192';
        if (total === 0) {
          ctaBtn.disabled = true;
          ctaBtn.textContent = baseLabel;
          ctaBtn.removeAttribute('aria-label');
        } else {
          ctaBtn.disabled = false;
          if (activeTier) {
            var ppbC = parseFloat(
              selectedPurchase === 'subscribe'
                ? activeTier.sub_price_per_bag
                : activeTier.onetime_price_per_bag
            );
            if (!isNaN(ppbC)) {
              var newTotalC = Math.round(total * ppbC * 100);
              var oldTotalC = getOldTotalCents(total, activeTier, selectedPurchase);
              var showWas = oldTotalC > newTotalC;
              var inner =
                '<span class="tlp-bundle__cta-inner">' +
                '<span class="tlp-bundle__cta-label">' + escapeHtml(baseLabel) + '</span>' +
                '<span class="tlp-bundle__cta-prices">' +
                (showWas
                  ? '<span class="tlp-bundle__cta-was"><s>' + formatMoney(oldTotalC) + '</s></span>'
                  : '') +
                '<span class="tlp-bundle__cta-now">' + formatMoney(newTotalC) + '</span>' +
                '</span></span>';
              ctaBtn.innerHTML = inner;
              var saveForAria = Math.max(0, oldTotalC - newTotalC);
              ctaBtn.setAttribute(
                'aria-label',
                'Add to cart. Total ' +
                  formatMoney(newTotalC) +
                  (showWas ? ', was ' + formatMoney(oldTotalC) : '') +
                  (saveForAria > 0 ? '. Save ' + formatMoney(saveForAria) : '')
              );
            } else {
              ctaBtn.textContent = baseLabel;
              ctaBtn.removeAttribute('aria-label');
            }
          } else {
            ctaBtn.textContent = baseLabel;
            ctaBtn.removeAttribute('aria-label');
          }
        }
      }
    }

    /* ── Qty button clicks ── */
    flavorsEl.addEventListener('click', function (e) {
      var incBtn = e.target.closest('.tlp-bundle__qty-inc');
      var decBtn = e.target.closest('.tlp-bundle__qty-dec');
      if (!incBtn && !decBtn) return;

      var vId = parseInt((incBtn || decBtn).dataset.variant, 10);
      if (!vId) return;

      if (incBtn) {
        qtys[vId] = (qtys[vId] || 0) + 1;
      } else {
        qtys[vId] = Math.max(0, (qtys[vId] || 0) - 1);
      }

      var display = flavorsEl.querySelector('[data-qty-display="' + vId + '"]');
      if (display) display.textContent = qtys[vId];

      updateUI();
    });

    /* ── Subscribe badge toggle ── */
    document.addEventListener('click', function (e) {
      var badge = e.target.closest('[data-tlp-sub-toggle]');
      if (!badge) return;

      /* If initOffer hasn't registered a toggle handler (no TlpProductData), do it here */
      if (!document.getElementById('TlpProductData')) {
        var isActive = badge.classList.toggle('is-active');
        badge.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }

      selectedPurchase = badge.classList.contains('is-active') ? 'subscribe' : 'one_time';
      updateUI();
    });

    /* ── Add to cart ── */
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var total = getTotalBags();
        if (total === 0) return;

        var items = [];
        variants.forEach(function (v) {
          var qty = qtys[v.id] || 0;
          if (qty === 0) return;
          var item = { id: v.id, quantity: qty };
          if (selectedPurchase === 'subscribe' && v.selling_plan_id) {
            item.selling_plan = v.selling_plan_id;
          }
          items.push(item);
        });

        if (!items.length) return;

        ctaBtn.disabled = true;
        ctaBtn.textContent = 'Adding\u2026';

        postCartAdd({ items: items })
          .then(function (data) {
            return completeCartAdd(data, { sourceId: 'tlp-bundle-atc', bundle: true });
          })
          .then(function () {
            ctaBtn.textContent = 'Added! \u2713';
            setTimeout(function () {
              ctaBtn.disabled = false;
              updateUI();
            }, 1800);
          })
          .catch(function () {
            ctaBtn.disabled = false;
            updateUI();
            alert('Something went wrong. Please try again.');
          });
      });
    }

    /* Initial render */
    updateUI();
  }

  /* ─ Countdown bar (duration-based) ─ */
  function initCountdown() {
    var bar = document.querySelector('[data-tlp-countdown-mins]');
    if (!bar) return;

    var durationMins = parseInt(bar.dataset.tlpCountdownMins, 10) || 10;
    var storageKey   = 'tlp_countdown_end';

    /* Persist end time in sessionStorage so refresh doesn't reset it */
    var stored  = sessionStorage.getItem(storageKey);
    var endTime = stored ? parseInt(stored, 10) : 0;
    if (!endTime || endTime <= Date.now()) {
      endTime = Date.now() + durationMins * 60 * 1000;
      sessionStorage.setItem(storageKey, endTime);
    }

    var hoursEl   = bar.querySelector('[data-tlp-hours]');
    var minutesEl = bar.querySelector('[data-tlp-minutes]');
    var secondsEl = bar.querySelector('[data-tlp-seconds]');

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        if (hoursEl)   hoursEl.textContent   = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        return;
      }
      var totalSecs = Math.floor(diff / 1000);
      var h = Math.floor(totalSecs / 3600);
      var m = Math.floor((totalSecs % 3600) / 60);
      var s = totalSecs % 60;

      if (hoursEl)   hoursEl.textContent   = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ─ Sticky header ─ */
  function initStickyHeader() {
    /* overflow:hidden on any ancestor breaks position:sticky — remove it */
    var main = document.getElementById('MainContent');
    if (main) main.style.overflow = 'visible';

    var header = document.querySelector('.tlp-header');
    if (!header) return;
    var wrapper = header.parentElement;
    if (!wrapper) return;
    wrapper.style.position = 'sticky';
    wrapper.style.top = '0';
    wrapper.style.zIndex = '200';
  }

  /* ─ Nutritional Info Modal ─ */
  function initNutritionModal() {
    var modal    = document.getElementById('tlp-nutrition-modal');
    var closeBtn = document.getElementById('tlp-nutrition-close');
    var backdrop = document.getElementById('tlp-nutrition-backdrop');
    if (!modal) return;

    var triggers = document.querySelectorAll('.tlp-nutrition-trigger');
    var tabs     = modal.querySelectorAll('[data-tlp-nutrition-tab]');
    var panels   = modal.querySelectorAll('.tlp-nutrition-modal__panel');

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'true'); });
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
    }

    function switchTab(idx) {
      tabs.forEach(function(t, i) {
        var active = i === idx;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function(p, i) { p.classList.toggle('is-active', i === idx); });
    }

    triggers.forEach(function(t) { t.addEventListener('click', openModal); });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        switchTab(parseInt(tab.getAttribute('data-tlp-nutrition-tab'), 10));
      });
    });
    document.addEventListener('keydown', function(e) {
      if (!modal.hidden && (e.key === 'Escape' || e.key === 'Esc')) closeModal();
    });
  }

  /* ─ Boot ─ */
  function init() {
    initStickyHeader();
    initCountdown();
    initReveal();
    initFaq();
    initOffer();
    initBundle();
    initProofCarousel();
    initCollageCarousel();
    initOfferGallery();
    initNutritionModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
